import { api } from '@/shared/api/api';
import { Table } from 'antd';
import { useEffect, useRef, useState } from 'react';
import GenerateNewSerialModal from '../GenerateNewSerialModal/GenerateNewSerialModal';
import { COLUMNS } from './SerialPage.constants';
import styles from './SerialPage.module.css';
import { useResize } from '@/shared/utils';

const SerialTable = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const { isMobile } = useResize();

  const abortControllerRef = useRef(null);

  useEffect(() => {
    fetchListDataSerial();

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const fetchListDataSerial = async () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    setLoading(true);
    const { data } = await api.get('/api/serial/get-all-serial', {
      signal: abortControllerRef.current.signal,
    });
    setData(data);
    setLoading(false);
  };

  const deleteHandler = async id => {
    await api.delete(`/api/serial/delete-serial?id=${id}`);
    fetchListDataSerial();
  };

  return (
    <>
      <div className={styles.tableHeader}>
        <GenerateNewSerialModal fetchData={fetchListDataSerial} />
      </div>
      <Table
        loading={loading}
        columns={COLUMNS(deleteHandler)}
        dataSource={data}
        pagination={false}
        locale={{ emptyText: 'Нет данных' }}
        scroll={
          isMobile
            ? null
            : {
                x: 1000,
              }
        }
        bordered
      />
    </>
  );
};

export default SerialTable;
